const tourData = [
  {
    id: 1,
    title: "The Sea Explorer",
    titleClass: "card__heading-span card__heading-span--1",
    backClass: "card__side card__side--back card__side--back-1",
    image: "card__image card__image--1",
    details: [
      "3 days tour",
      "up to 30 people",
      "2 tour guides",
      "sleep in cozy hotels",
      "Difficulty: easy",
    ],
    price: "$250",
  },
  {
    id: 2,
    title: "The Forest hiker",
    titleClass: "card__heading-span card__heading-span--2",
    backClass: "card__side card__side--back card__side--back-2",
    image: "card__image card__image--2",
    details: [
      "7 days tour",
      "up to 40 people",
      "6 tour guides",
      "sleep in cozy tents",
      "Difficulty: medium",
    ],
    price: "$450",
  },
  {
    id: 3,
    title: "The snow adventurer",
    titleClass: "card__heading-span card__heading-span--3",
    backClass: "card__side card__side--back card__side--back-3",
    image: "card__image card__image--3",
    details: [
      "5 days tour",
      "up to 15 people",
      "3 tour guides",
      "sleep in cozy hotels",
      "Difficulty: hard",
    ],
    price: "$600",
  },
];

export default tourData;
